import { LocationRoomsState, LocationRoomsActionTypes, LOCATION_ROOMS_REQUEST, LOCATION_ROOMS_SUCCESS, LOCATION_ROOMS_FAILURE } from "store/reducers/room/locationRooms/types";

const defaultState: LocationRoomsState = {
  isLoading: false,
  errorMessage: ""
};

export default function getLocationRoomsData(state = defaultState, action: LocationRoomsActionTypes): LocationRoomsState {
  switch (action.type) {
    case LOCATION_ROOMS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LOCATION_ROOMS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LOCATION_ROOMS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};